<template>
  <div>
    <IsiTeks :class="isAdmin" halaman="daftar-pustaka" />
  </div>
</template>

<script>
import IsiTeks from '../components/IsiTeks'

export default {
  data() {
    return {
      role: this.$store.state.user.displayName
    }
  },
  components: {
    IsiTeks
  },
  computed: {
    isAdmin: function () {
      return this.role != 'admin' ? 'daftar-pustaka' : ''
    }
  }
}
</script>